<template>
  <v-dialog v-model="dialog" @input="v => v || closeAssignModal()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <v-card-text>
        <div class="text-center py-10">
          <v-img
            @click="closeAssignModal"
            class="cancel-image"
            src="../../assets/icons/cancel.png"
            height="15px"
            width="15px"
          />
          <h3>{{ dialogTitle | translate}}</h3>
        </div>
        <v-form class="ma-2 mt-3" ref="assignSystem" lazy-validation>
          
          <v-text-field 
            :label="'lng_sewer_id_txt' | translate"
            v-model="newId" :rules="[rules.required]"></v-text-field>
          <v-text-field 
            :label="'lng_sewer_pass_txt' | translate"
            v-model="newPass" :rules="[rules.required]"></v-text-field>
          
          <p class="warning-error mt-2" v-if="error">{{ error }}</p>
          <div class="date-header d-flex justify-content-center py-5 mt-3">
            <v-btn color="#0B7894" dark @click="validate" :loading="showLoading">{{ "lng_save_txt" | translate }}</v-btn>
          </div>
        </v-form>
      </v-card-text>
      <Alert
        v-if="alertToggle"
        :message-data="flashMessageData"
        :alert-toggle="alertToggle"
        @alertToggleUpdate="alertToggle = false"
      />
    </v-card>
  </v-dialog>
</template>
  
<script>
import GlobalService from "../../services/global-service";
import { translateFunc } from '../../common/Filters';
import Alert from "../../components/Alert"

export default {
  name: "AssignSystemItself",
  components: {
    Alert
  },
  data() {
    return {
      dialog: false,
      newId: "",
      newPass: "",
      rules: {
        required: value => !!value || translateFunc("lng_required_text"),
        counter: value => value.length <= 20 || translateFunc("lng_required_length"),
      },
      showLoading: false,
      error: "",
      alertToggle: false,
      flashMessageData: {},
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "lng_assign_itself_txt"
    },
    userToken: {
      type: String,
      default: ""
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
  },
  mounted() {},
  methods: {
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.assignSystem.validate()) {
          this.saveBox();
        }
      });
    },
    async saveBox() {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        response = await GlobalService.assignSystemItselfDealer(
          this.userToken,
          this.newId,
          this.newPass
        );
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        this.showAlert({msg: translateFunc("lng_try_again_txt"), status: 1});
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        this.$emit("updateLocalData");
        this.closeAssignModal()
        this.showAlert(response);
      } else {
        this.showLoading = false;
        this.error = response.msg;
        this.showAlert(response);
      }
    },
    closeAssignModal(){
      this.error = "";
      this.newId = "",
      this.newPass = "",
      this.closeDialog()
    },
    showAlert(res){
      this.flashMessageData = res;
      this.alertToggle = true;
    }
  }
};
</script>
<style scoped>
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 90%;
}
.cancel-image {
  cursor: pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
</style>
  